"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectAttachmentPreferencesOption_1 = require("../actions/selectAttachmentPreferencesOption");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var AttachmentPreferencesChoiceGroup = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesChoiceGroup, _super);
    function AttachmentPreferencesChoiceGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectAttachmentPreferencesOption_1.default(_this.props.optionKey, parseInt(option.key, 10));
        };
        return _this;
    }
    AttachmentPreferencesChoiceGroup.prototype.render = function () {
        var _a = this.props, selectedKey = _a.selectedKey, label = _a.label;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + selectedKey, label: label, options: [
                {
                    key: "" + 0 /* None */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_askOption,
                },
                {
                    key: "" + 2 /* Share */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_shareOption,
                },
                {
                    key: "" + 1 /* Attach */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_attachOption,
                },
            ], onChange: this.onChange }));
    };
    AttachmentPreferencesChoiceGroup = tslib_1.__decorate([
        mobx_react_1.observer
    ], AttachmentPreferencesChoiceGroup);
    return AttachmentPreferencesChoiceGroup;
}(React.Component));
exports.default = AttachmentPreferencesChoiceGroup;
//# sourceMappingURL=AttachmentPreferencesChoiceGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/components/AttachmentPreferencesChoiceGroup.js
// module id = 4981
// module chunks = 2